import { registerTranslateConfig } from 'lit-translate';
import { es, ptBr } from '../lang';
// import('../lang/es.json');
// import('../lang/en.json');
export default () => {
    return registerTranslateConfig({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        loader: lang => {
            switch (lang) {
                case 'es':
                    return es();
                default:
                    return ptBr();
                // case 'es':
                //   return fetch(`src/lang/${lang}.json`).then(res => res.json())
            }
        },
    });
};
//# sourceMappingURL=registerTranslateConfig.js.map